/**
 * Returns how many array groups (sets) to show per line on mobile.
 * Uses settings.mobileSetsPerLine when set (e.g. "1", "2", "3", "4"), otherwise defaults to 1.
 */
export const getMobileSetsPerLine = (settings: {
  mobileSetsPerLine?: string;
}): number => {
  const value = settings.mobileSetsPerLine;
  if (value === undefined || value === "") return 1;
  const num = Number(value);
  return Number.isFinite(num) && num >= 1 ? num : 1;
};
